const cnNameToTrackData = {
  '首页-进入/退出': { pagename_cn: '首页' },
  '首页-顶部banner-曝光': {
    pagename_cn: '首页',
    element_tag: '首页#top_banner#null#null'
  },
  '首页-顶部banner-婚礼纪商家app-点击': {
    pagename_cn: '首页',
    element_tag: '首页#top_banner#hlj_merch_app_button#null'
  },
  '首页-顶部banner-官网首页-点击': {
    pagename_cn: '首页',
    element_tag: '首页#top_banner#official_web_button#null'
  },
  '首页-顶部banner-联系我们-点击': {
    pagename_cn: '首页',
    element_tag: '首页#top_banner#contact_us#null'
  },
  '首页-店铺微官网-点击': {
    pagename_cn: '首页',
    element_tag: '首页#top_banner#wstore_web_button#null'
  },
  '首页-店铺官网-点击': {
    pagename_cn: '首页',
    element_tag: '首页#top_banner#store_web_button#null'
  },
  '首页-当前服务-曝光': {
    pagename_cn: '首页',
    element_tag: '首页#current_serve#null#null'
  },
  '首页-当前服务-商家服务-点击': {
    pagename_cn: '首页',
    element_tag: '首页#current_serve#merch_serve_button#null'
  },
  '首页-当前服务-普通商家-点击': {
    pagename_cn: '首页',
    element_tag: '首页#current_serve#normal_merch_button#null'
  },
  '商家等级页-进入/退出': { pagename_cn: '商家等级页' },
  '商家等级页-商家等级-曝光': {
    pagename_cn: '商家等级页',
    element_tag: '商家等级页#merch_grade#null#null'
  },
  '商家等级页-商家等级-查看等级规则-点击': {
    pagename_cn: '商家等级页',
    element_tag: '商家等级页#merch_grade#check_role_button#null'
  },
  '首页-系统公告-曝光': {
    pagename_cn: '首页',
    element_tag: '首页#system_note#null#null'
  },
  '首页-系统公告-更多-点击': {
    pagename_cn: '首页',
    element_tag: '首页#system_note#more_button#null'
  },
  '首页-系统公告-公告详情-点击': {
    pagename_cn: '首页',
    element_tag: '首页#system_note#note_detail_button#null'
  },
  '首页-平台活动-曝光': {
    pagename_cn: '首页',
    element_tag: '首页#platform_activity#null#null'
  },
  '首页-平台活动-更多-点击': {
    pagename_cn: '首页',
    element_tag: '首页#platform_activity#more_button#null'
  },
  '首页-常用功能-曝光': {
    pagename_cn: '首页',
    element_tag: '首页#normal_function#null#null'
  },
  '首页-常用功能-发动态-点击': {
    pagename_cn: '首页',
    element_tag: '首页#normal_function#publish_activity_button#null'
  },
  '首页-常用功能-微传单-点击': {
    pagename_cn: '首页',
    element_tag: '首页#normal_function#whandbill_button#null'
  },
  '首页-常用功能-传相册-点击': {
    pagename_cn: '首页',
    element_tag: '首页#normal_function#photo_button#null'
  },
  '首页-常用功能-传场地-点击': {
    pagename_cn: '首页',
    element_tag: '首页#normal_function#area_button#null'
  },
  '首页-常用功能-传菜单-点击': {
    pagename_cn: '首页',
    element_tag: '首页#normal_function#menu_button#null'
  },
  '首页-常用功能-优惠券-点击': {
    pagename_cn: '首页',
    element_tag: '首页#normal_function#coupon_button#null'
  },
  '首页-常用功能-智优投-点击': {
    pagename_cn: '首页',
    element_tag: '首页#normal_function#zyt_button#null'
  },
  '首页-常用功能-发创意-点击': {
    pagename_cn: '首页',
    element_tag: '首页#normal_function#create_button#null'
  },
  '首页-行业信息列表-曝光': {
    pagename_cn: '首页',
    element_tag: '首页#industry_info#null#null'
  },
  '首页-行业信息列表-推荐-点击': {
    pagename_cn: '首页',
    element_tag: '首页#industry_info#recommend_button#null'
  },
  '首页-行业信息列表-营销干货-点击': {
    pagename_cn: '首页',
    element_tag: '首页#industry_info#market_button#null'
  },
  '首页-行业信息列表-产品功能-点击': {
    pagename_cn: '首页',
    element_tag: '首页#industry_info#product_func_button#null'
  },
  '首页-行业信息列表-行业资讯-点击': {
    pagename_cn: '首页',
    element_tag: '首页#industry_info#industry_info_button#null'
  },
  '首页-行业信息列表-开店必看-点击': {
    pagename_cn: '首页',
    element_tag: '首页#industry_info#open_store_button#null'
  },
  '首页-行业信息列表-信息标题-点击': {
    pagename_cn: '首页',
    element_tag: '首页#industry_info#info_title_button#null'
  },
  '酒店店铺装修页-进入/退出': { pagename_cn: '酒店店铺装修页' },
  '酒店店铺装修页-店铺装修-曝光': {
    pagename_cn: '酒店店铺装修页',
    element_tag: '酒店店铺装修页#store_remodel#null#null'
  },
  '酒店店铺装修页-店铺装修-封面设置-点击': {
    pagename_cn: '酒店店铺装修页',
    element_tag: '酒店店铺装修页#store_remodel#cover_set_button#null'
  },
  '酒店店铺装修页-店铺装修-特色信息-点击': {
    pagename_cn: '酒店店铺装修页',
    element_tag: '酒店店铺装修页#store_remodel#special_info_button#null'
  },
  '酒店店铺装修页-店铺装修-修改店铺资料-点击': {
    pagename_cn: '酒店店铺装修页',
    element_tag: '酒店店铺装修页#store_remodel#change_store_data_button#null'
  },
  '酒店店铺装修页-店铺装修-专享优惠-点击': {
    pagename_cn: '酒店店铺装修页',
    element_tag: '酒店店铺装修页#store_remodel#particular_discount_button#null'
  },
  '酒店店铺装修页-店铺装修-场地管理-点击': {
    pagename_cn: '酒店店铺装修页',
    element_tag: '酒店店铺装修页#store_remodel#area_manage_button#null'
  },
  '酒店店铺装修页-店铺装修-菜单管理-点击': {
    pagename_cn: '酒店店铺装修页',
    element_tag: '酒店店铺装修页#store_remodel#bill_manage_button#null'
  },
  '酒店店铺装修页-店铺装修-套餐管理-点击': {
    pagename_cn: '酒店店铺装修页',
    element_tag: '酒店店铺装修页#store_remodel#meal_manage_button#null'
  },
  '酒店店铺装修页-店铺装修-微传单-点击': {
    pagename_cn: '酒店店铺装修页',
    element_tag: '酒店店铺装修页#store_remodel#whandbill_button#null'
  },
  '酒店店铺装修页-店铺装修-婚策案例-点击': {
    pagename_cn: '酒店店铺装修页',
    element_tag: '酒店店铺装修页#store_remodel#hc_case_button#null'
  },
  '酒店店铺装修页-店铺装修-评价管理-点击': {
    pagename_cn: '酒店店铺装修页',
    element_tag: '酒店店铺装修页#store_remodel#judge_manage_button#null'
  },
  '酒店店铺装修页-店铺装修-天眼系统-点击': {
    pagename_cn: '酒店店铺装修页',
    element_tag: '酒店店铺装修页#store_remodel#eye_system_button#null'
  },
  '酒店店铺装修页-店铺装修-戳我-点击': {
    pagename_cn: '酒店店铺装修页',
    element_tag: '酒店店铺装修页#store_remodel#click_me_button#null'
  },
  '封面设置页-进入/退出': { pagename_cn: '封面设置页' },
  '封面设置页-封面设置-曝光': {
    pagename_cn: '封面设置页',
    element_tag: '封面设置页#cover_set#null#null'
  },
  '封面设置页-封面设置-图片封面-从相册添加-点击': {
    pagename_cn: '封面设置页',
    element_tag: '封面设置页#cover_set#picture_photo_append_button#null'
  },
  '封面设置页-封面设置-视频-点击': {
    pagename_cn: '封面设置页',
    element_tag: '封面设置页#cover_set#video_button#null'
  },
  '封面设置页-封面设置-图片-点击': {
    pagename_cn: '封面设置页',
    element_tag: '封面设置页#cover_set#picture_button#null'
  },
  '封面设置页-封面设置-查看攻略-点击': {
    pagename_cn: '封面设置页',
    element_tag: '封面设置页#cover_set#method_button#null'
  },
  '封面设置页-封面设置-视频封面-从相册添加-点击': {
    pagename_cn: '封面设置页',
    element_tag: '封面设置页#cover_set#video_photo_append_button#null'
  },
  '封面设置页-封面设置-保存-点击': {
    pagename_cn: '封面设置页',
    element_tag: '封面设置页#cover_set#save_button#null'
  },
  '特色信息页-进入/退出': { pagename_cn: '特色信息页' },
  '特色信息页-特色信息-曝光': {
    pagename_cn: '特色信息页',
    element_tag: '特色信息页#special_info#null#null'
  },
  '特色信息页-特色信息-保存-点击': {
    pagename_cn: '特色信息页',
    element_tag: '特色信息页#special_info#save_button#null'
  },
  '专享优惠页-进入/退出': { pagename_cn: '专享优惠页' },
  '专享优惠页-专享优惠-曝光': {
    pagename_cn: '专享优惠页',
    element_tag: '专享优惠页#particular_discount#null#null'
  },
  '专享优惠页-专享优惠-保存-点击': {
    pagename_cn: '专享优惠页',
    element_tag: '专享优惠页#particular_discount#save_button#null'
  },
  '主体模板页-进入/退出': { pagename_cn: '主体模板页' },
  '主体模板页-主题模板-曝光': {
    pagename_cn: '主体模板页',
    element_tag: '主体模板页#subject_model#null#null'
  },
  '主体模板页-主题模板-选择-点击': {
    pagename_cn: '主体模板页',
    element_tag: '主体模板页#subject_model#select_button#null'
  },
  '微官网页-进入/退出': { pagename_cn: '微官网页' },
  '微官网页-模块设置-曝光': {
    pagename_cn: '微官网页',
    element_tag: '微官网页#model_set#null#null'
  },
  '微官网页-模块设置-预览-点击': {
    pagename_cn: '微官网页',
    element_tag: '微官网页#model_set#preview_button#null'
  },
  '微官网页-模块设置-保存设置-点击': {
    pagename_cn: '微官网页',
    element_tag: '微官网页#model_set#save_set_button#null'
  },
  '相册管理页-进入/退出': { pagename_cn: '相册管理页' },
  '相册管理页-外部环境-曝光': {
    pagename_cn: '相册管理页',
    element_tag: '相册管理页#outside_env#null#null'
  },
  '相册管理页-外部环境-保存-点击': {
    pagename_cn: '相册管理页',
    element_tag: '相册管理页#outside_env#save_button#null'
  },
  '相册管理页-大堂-曝光': {
    pagename_cn: '相册管理页',
    element_tag: '相册管理页#lobby#null#null'
  },
  '相册管理页-大堂-保存-点击': {
    pagename_cn: '相册管理页',
    element_tag: '相册管理页#lobby#save_button#null'
  },
  '相册管理页-新娘房-曝光': {
    pagename_cn: '相册管理页',
    element_tag: '相册管理页#bride_room#null#null'
  },
  '相册管理页-新娘房-保存-点击': {
    pagename_cn: '相册管理页',
    element_tag: '相册管理页#bride_room#save_button#null'
  },
  '相册管理页-客房-曝光': {
    pagename_cn: '相册管理页',
    element_tag: '相册管理页#guest_room#null#null'
  },
  '相册管理页-客房-保存-点击': {
    pagename_cn: '相册管理页',
    element_tag: '相册管理页#guest_room#save_button#null'
  },
  '相册管理页-特色场地-曝光': {
    pagename_cn: '相册管理页',
    element_tag: '相册管理页#special_area#null#null'
  },
  '相册管理页-特色场地-保存-点击': {
    pagename_cn: '相册管理页',
    element_tag: '相册管理页#special_area#save_button#null'
  },
  '相册管理页-网红打卡点-曝光': {
    pagename_cn: '相册管理页',
    element_tag: '相册管理页#red_hot_area#null#null'
  },
  '相册管理页-网红打卡点-保存-点击': {
    pagename_cn: '相册管理页',
    element_tag: '相册管理页#red_hot_area#save_button#null'
  },
  '相册管理页-VR全景-曝光': {
    pagename_cn: '相册管理页',
    element_tag: '相册管理页#vr_full_scene#null#null'
  },
  '相册管理页-VR全景-保存-点击': {
    pagename_cn: '相册管理页',
    element_tag: '相册管理页#vr_full_scene#save_button#null'
  },
  '相册管理页-视频-曝光': {
    pagename_cn: '相册管理页',
    element_tag: '相册管理页#video#null#null'
  },
  '相册管理页-视频-保存-点击': {
    pagename_cn: '相册管理页',
    element_tag: '相册管理页#video#save_button#null'
  },
  '场地页-进入/退出': { pagename_cn: '场地页' },
  '场地页-顶部banner-曝光': {
    pagename_cn: '场地页',
    element_tag: '场地页#top_banner#null#null'
  },
  '场地页-顶部banner-场地排序-点击': {
    pagename_cn: '场地页',
    element_tag: '场地页#top_banner#area_rank_button#null'
  },
  '场地页-顶部banner-发布场地-点击': {
    pagename_cn: '场地页',
    element_tag: '场地页#top_banner#publish_area_button#null'
  },
  '场地页-已上架-曝光': {
    pagename_cn: '场地页',
    element_tag: '场地页#put_sale#null#null'
  },
  '场地页-审核中-曝光': {
    pagename_cn: '场地页',
    element_tag: '场地页#auditing#null#null'
  },
  '场地页-审核未通过-曝光': {
    pagename_cn: '场地页',
    element_tag: '场地页#un_audit#null#null'
  },
  '场地页-已下架-曝光': {
    pagename_cn: '场地页',
    element_tag: '场地页#down_sale#null#null'
  },
  '场地页-已上架-编辑-点击': {
    pagename_cn: '场地页',
    element_tag: '场地页#put_sale#edit_button#null'
  },
  '场地页-已上架-下架-点击': {
    pagename_cn: '场地页',
    element_tag: '场地页#put_sale#down_sale_button#null'
  },
  '场地页-已上架-删除-点击': {
    pagename_cn: '场地页',
    element_tag: '场地页#put_sale#delete_button#null'
  },
  '场地页-审核未通过-编辑-点击': {
    pagename_cn: '场地页',
    element_tag: '场地页#un_audit#edit_button#null'
  },
  '场地页-审核未通过-删除-点击': {
    pagename_cn: '场地页',
    element_tag: '场地页#un_audit#delete_button#null'
  },
  '场地页-已下架-编辑-点击': {
    pagename_cn: '场地页',
    element_tag: '场地页#down_sale#edit_button#null'
  },
  '场地页-已下架-上架-点击': {
    pagename_cn: '场地页',
    element_tag: '场地页#down_sale#put_sale_button#null'
  },
  '场地页-已下架-删除-点击': {
    pagename_cn: '场地页',
    element_tag: '场地页#down_sale#delete_button#null'
  },
  '菜单页-进入/退出': { pagename_cn: '菜单页' },
  '菜单页-顶部banner-曝光': {
    pagename_cn: '菜单页',
    element_tag: '菜单页#top_banner#null#null'
  },
  '菜单页-顶部banner-菜单排序-点击': {
    pagename_cn: '菜单页',
    element_tag: '菜单页#top_banner#bill_rank_button#null'
  },
  '菜单页-顶部banner-发布菜单-点击': {
    pagename_cn: '菜单页',
    element_tag: '菜单页#top_banner#publish_bill_button#null'
  },
  '菜单页-已上架-曝光': {
    pagename_cn: '菜单页',
    element_tag: '菜单页#put_sale#null#null'
  },
  '菜单页-审核中-曝光': {
    pagename_cn: '菜单页',
    element_tag: '菜单页#auditing#null#null'
  },
  '菜单页-审核未通过-曝光': {
    pagename_cn: '菜单页',
    element_tag: '菜单页#un_audit#null#null'
  },
  '菜单页-已下架-曝光': {
    pagename_cn: '菜单页',
    element_tag: '菜单页#down_sale#null#null'
  },
  '菜单页-已上架-下架-点击': {
    pagename_cn: '菜单页',
    element_tag: '菜单页#put_sale#down_sale_button#null'
  },
  '菜单页-已上架-编辑-点击': {
    pagename_cn: '菜单页',
    element_tag: '菜单页#put_sale#edit_button#null'
  },
  '菜单页-已上架-删除-点击': {
    pagename_cn: '菜单页',
    element_tag: '菜单页#put_sale#delete_button#null'
  },
  '套餐管理页-进入/退出': { pagename_cn: '套餐管理页' },
  '套餐管理页-发布套餐-点击': {
    pagename_cn: '套餐管理页',
    element_tag: '套餐管理页#null#publish_meal_button#null'
  },
  '套餐管理页-草稿箱-点击': {
    pagename_cn: '套餐管理页',
    element_tag: '套餐管理页#null#draft_button#null'
  },
  '套餐管理页-草稿箱-发布套餐-点击': {
    pagename_cn: '套餐管理页',
    element_tag: '套餐管理页#draft#publish_meal_button#null'
  },
  '套餐管理页-草稿箱-编辑-点击': {
    pagename_cn: '套餐管理页',
    element_tag: '套餐管理页#draft#edit_button#null'
  },
  '套餐管理页-草稿箱-删除-点击': {
    pagename_cn: '套餐管理页',
    element_tag: '套餐管理页#draft#delete_button#null'
  },
  '套餐管理页-已上架-曝光': {
    pagename_cn: '套餐管理页',
    element_tag: '套餐管理页#put_sale#null#null'
  },
  '套餐管理页-已下架-曝光': {
    pagename_cn: '套餐管理页',
    element_tag: '套餐管理页#down_sale#null#null'
  },
  '套餐管理页-已上架-下架-点击': {
    pagename_cn: '套餐管理页',
    element_tag: '套餐管理页#put_sale#down_sale_button#null'
  },
  '套餐管理页-已下架-上架-点击': {
    pagename_cn: '套餐管理页',
    element_tag: '套餐管理页#down_sale#put_sale_button#null'
  },
  '套餐管理页-已上架-编辑-点击': {
    pagename_cn: '套餐管理页',
    element_tag: '套餐管理页#put_sale#edit_button#null'
  },
  '套餐管理页-已上架-删除-点击': {
    pagename_cn: '套餐管理页',
    element_tag: '套餐管理页#put_sale#delete_button#null'
  },
  'VR全景页-进入/退出': { pagename_cn: 'VR全景页' },
  'VR全景页-顶部banner-曝光': {
    pagename_cn: 'VR全景页',
    element_tag: 'VR全景页#top_banner#null#null'
  },
  'VR全景页-顶部banner-全景排序-点击': {
    pagename_cn: 'VR全景页',
    element_tag: 'VR全景页#top_banner#full_scene_rank_button#null'
  },
  'VR全景页-顶部banner-添加VR全景-点击': {
    pagename_cn: 'VR全景页',
    element_tag: 'VR全景页#top_banner#full_scene_append_button#null'
  },
  'VR全景页-搜索-点击': {
    pagename_cn: 'VR全景页',
    element_tag: 'VR全景页#null#select_button#null'
  },
  '动态管理页-进入/退出': { pagename_cn: '动态管理页' },
  '动态管理页-搜索-点击': {
    pagename_cn: '动态管理页',
    element_tag: '动态管理页#null#select_button#null'
  },
  '动态管理页-发布动态-点击': {
    pagename_cn: '动态管理页',
    element_tag: '动态管理页#null#publish_dynamic_button#null'
  },
  '动态管理页-内容信息列表-曝光': {
    pagename_cn: '动态管理页',
    element_tag: '动态管理页#content_info_list#null#null'
  },
  '动态管理页-内容信息列表-查看-点击': {
    pagename_cn: '动态管理页',
    element_tag: '动态管理页#content_info_list#check_button#null'
  },
  '动态管理页-内容信息列表-置顶-点击': {
    pagename_cn: '动态管理页',
    element_tag: '动态管理页#content_info_list#set_top_button#null'
  },
  '动态管理页-内容信息列表-删除-点击': {
    pagename_cn: '动态管理页',
    element_tag: '动态管理页#content_info_list#delete_button#null'
  },
  '一站式服务配置页-进入/退出': {
    pagename_cn: '一站式服务配置页',
    element_tag: '一站式服务配置页-进入/退出	一站式服务配置页'
  },
  '一站式服务配置页-服务配置-曝光': {
    pagename_cn: '一站式服务配置页',
    element_tag: '一站式服务配置页#serve_set#null#null'
  },
  '一站式服务配置页-服务配置-橱窗图片编辑-点击': {
    pagename_cn: '一站式服务配置页',
    element_tag: '一站式服务配置页#serve_set#cc_picture_edit_button#null'
  },
  '一站式服务配置页-服务配置-门店信息编辑-点击': {
    pagename_cn: '一站式服务配置页',
    element_tag: '一站式服务配置页#serve_set#md_info_edit_button#null'
  },
  '一站式服务配置页-服务配置-发布-点击': {
    pagename_cn: '一站式服务配置页',
    element_tag: '一站式服务配置页#serve_set#publish_button#null'
  },
  '购买记录页-进入/退出': { pagename_cn: '购买记录页' },
  '购买记录页-搜索-点击': {
    pagename_cn: '购买记录页',
    element_tag: '购买记录页#null#select_button#null'
  },
  '购买记录页-重置-点击': {
    pagename_cn: '购买记录页',
    element_tag: '购买记录页#null#reset_button#null'
  },
  '购买记录页-开票申请-点击': {
    pagename_cn: '购买记录页',
    element_tag: '购买记录页#null#fill_apply_button#null'
  },
  '购买记录页-订单信息列表-曝光': {
    pagename_cn: '购买记录页',
    element_tag: '购买记录页#order_info_list#null#null'
  },
  '购买记录页-订单信息列表-详情-点击': {
    pagename_cn: '购买记录页',
    element_tag: '购买记录页#order_info_list#detail_button#null'
  },
  '优惠券页-进入/退出': { pagename_cn: '优惠券页' },
  '优惠券页-兑换-点击': {
    pagename_cn: '优惠券页',
    element_tag: '优惠券页#null#exchange_button#null'
  },
  '优惠券页-未使用-曝光': {
    pagename_cn: '优惠券页',
    element_tag: '优惠券页#null#unuse_button#null'
  },
  '经营客资管理页-进入/退出': { pagename_cn: '经营客资管理页' },
  '经营客资管理页-客资详情列表-曝光': {
    pagename_cn: '经营客资管理页',
    element_tag: '经营客资管理页#customer_detail_list#null#null'
  },
  '经营客资管理页-客资详情列表-录入客资-点击': {
    pagename_cn: '经营客资管理页',
    element_tag: '经营客资管理页#customer_detail_list#load_customer_button#null'
  },
  '经营客资管理页-客资详情列表-查看详情-点击': {
    pagename_cn: '经营客资管理页',
    element_tag: '经营客资管理页#customer_detail_list#check_detail_button#null'
  },
  '经营通知管理页-进入/退出': { pagename_cn: '经营通知管理页' },
  '经营通知管理页-微信通知-曝光': {
    pagename_cn: '经营通知管理页',
    element_tag: '经营客资管理页#wechat_notice#null#null'
  },
  '经营通知管理页-微信通知-点击扫码绑定-点击': {
    pagename_cn: '经营通知管理页',
    element_tag: '经营客资管理页#wechat_notice#scan_code_button#null'
  },
  '经营通知管理页-微信通知-解绑-点击': {
    pagename_cn: '经营通知管理页',
    element_tag: '经营客资管理页#wechat_notice#unbound_button#null'
  },
  '经营通知管理页-微信通知-测试一下-点击': {
    pagename_cn: '经营通知管理页',
    element_tag: '经营客资管理页#wechat_notice#try_button#null'
  },
  '设置通知管理页-顾客未及时接待通知-曝光': {
    pagename_cn: '经营通知管理页',
    element_tag: '设置通知管理页#gkwjsjdtz#null#null'
  },
  '经营通知管理页-顾客未及时接待通知-电话-点击': {
    pagename_cn: '经营通知管理页',
    element_tag: '设置通知管理页#gkwjsjdtz#phone_button#null'
  },
  '经营通知管理页-顾客未及时接待通知-短信-点击': {
    pagename_cn: '经营通知管理页',
    element_tag: '设置通知管理页#gkwjsjdtz#info_button#null'
  },
  '经营通知管理页-顾客未及时接待通知-不通知-点击': {
    pagename_cn: '经营通知管理页',
    element_tag: '设置通知管理页#gkwjsjdtz#no_notice_button#null'
  },
  '经营通知管理页-顾客未及时接待通知-短信-店铺付费专享-点击': {
    pagename_cn: '经营通知管理页',
    element_tag: '设置通知管理页#gkwjsjdtz#info#store_pay_button'
  },
  '评价管理页-进入/退出': { pagename_cn: '评价管理页' },
  '评价管理页-评价详情列表-曝光': {
    pagename_cn: '评价管理页',
    element_tag: '评价管理页#judge_list#null#null'
  },
  '评价管理页-评价详情列表-申诉-点击': {
    pagename_cn: '评价管理页',
    element_tag: '评价管理页#judge_list#appeal_button#null'
  },
  '评价管理页-评价详情列表-回复-点击': {
    pagename_cn: '评价管理页',
    element_tag: '评价管理页#judge_list#reply_button#null'
  },
  '评价管理页-评价详情列表-发起私信-点击': {
    pagename_cn: '评价管理页',
    element_tag: '评价管理页#judge_list#private_info_button#null'
  },
  '列表模式页-进入/退出': { pagename_cn: '列表模式页' },
  '列表模式页-档期列表-曝光': {
    pagename_cn: '列表模式页',
    element_tag: '列表模式页#schedule_list#null#null'
  },
  '列表模式页-档期列表-新建档期-点击': {
    pagename_cn: '列表模式页',
    element_tag: '列表模式页#schedule_list#create_schedule_button#null'
  },
  '列表模式页-档期列表-查询-点击': {
    pagename_cn: '列表模式页',
    element_tag: '列表模式页#schedule_list#select_button#null'
  },
  '日历模式页-进入/退出': { pagename_cn: '日历模式页' },
  '日历模式页-宴会厅列表-曝光': {
    pagename_cn: '日历模式页',
    element_tag: '日历模式页#yht_list#null#null'
  },
  '日历模式页-宴会厅列表-新建档期-点击': {
    pagename_cn: '日历模式页',
    element_tag: '日历模式页#yht_list#create_schedule_button#null'
  },
  '日历模式页-宴会厅列表-查询-点击': {
    pagename_cn: '日历模式页',
    element_tag: '日历模式页#yht_list#select_button#null'
  },
  '日历模式页-宴会厅列表-重置-点击': {
    pagename_cn: '日历模式页',
    element_tag: '日历模式页#yht_list#reset_button#null'
  },
  '营销页-进入/退出': { pagename_cn: '营销页' },
  '营销页-营销工具-曝光': {
    pagename_cn: '营销页',
    element_tag: '营销页#market_tool#null#null'
  },
  '营销页-营销工具-海草名片-点击': {
    pagename_cn: '营销页',
    element_tag: '营销页#market_tool#hcmp_button#null'
  },
  '营销页-营销工具-微传单-点击': {
    pagename_cn: '营销页',
    element_tag: '营销页#market_tool#wbill_button#null'
  },
  '营销页-营销工具-视频直播-点击': {
    pagename_cn: '营销页',
    element_tag: '营销页#market_tool#video_button#null'
  },
  '营销页-营销转化-曝光': {
    pagename_cn: '营销页',
    element_tag: '营销页#market_change#null#null'
  },
  '营销页-营销工具-天眼系统-点击': {
    pagename_cn: '营销页',
    element_tag: '营销页#market_tool#eye_system_button#null'
  },
  '营销页-营销工具-平台活动-点击': {
    pagename_cn: '营销页',
    element_tag: '营销页#market_tool#platform_activity_button#null'
  },
  '营销页-营销工具-预设问题-点击': {
    pagename_cn: '营销页',
    element_tag: '营销页#market_tool#pre_question_button#null'
  },
  '营销页-营销工具-私信接待助手-点击': {
    pagename_cn: '营销页',
    element_tag: '营销页#market_tool#private_info_button#null'
  },
  '营销页-服务工具-曝光': {
    pagename_cn: '营销页',
    element_tag: '营销页#serve_tool#null#null'
  },
  '营销页-营销工具-电子请帖-点击': {
    pagename_cn: '营销页',
    element_tag: '营销页#serve_tool#dzqt_button#null'
  },
  '营销页-营销工具-婚礼mv-点击': {
    pagename_cn: '营销页',
    element_tag: '营销页#serve_tool#wedding_mv_button#null'
  },
  '营销页-营销工具-婚礼现场-点击': {
    pagename_cn: '营销页',
    element_tag: '营销页#serve_tool#wedding_scene_button#null'
  },
  '推广首页-进入/退出': { pagename_cn: '推广首页' },
  '推广首页-推广概览-曝光': {
    pagename_cn: '推广首页',
    element_tag: '推广首页#promote_summary#null#null'
  },
  '推广首页-推广概览-立即激活-点击': {
    pagename_cn: '推广首页',
    element_tag: '推广首页#promote_summary#activation_button#null'
  },
  '推广首页-推广概览-购买套包-点击': {
    pagename_cn: '推广首页',
    element_tag: '推广首页#promote_summary#buy_meal_button#null'
  },
  '推广首页-推广概览-充值-点击': {
    pagename_cn: '推广首页',
    element_tag: '推广首页#promote_summary#input_button#null'
  },
  '推广首页-推广概览-问题计划-点击': {
    pagename_cn: '推广首页',
    element_tag: '推广首页#promote_summary#question_plan_button#null'
  },
  '推广首页-推广概览-问题素材-点击': {
    pagename_cn: '推广首页',
    element_tag: '推广首页#promote_summary#question_matter_button#null'
  },
  '智优投页-进入/退出': { pagename_cn: '智优投页' },
  '智优投页-使用帮助-点击': {
    pagename_cn: '智优投页',
    element_tag: '智优投页#null#use_help_button#null'
  },
  '智优投页-产品介绍-点击': {
    pagename_cn: '智优投页',
    element_tag: '智优投页#null#product_introduce_button#null'
  },
  '智优投页-充值-点击': {
    pagename_cn: '智优投页',
    element_tag: '智优投页#null#input_button#null'
  },
  '智优投页-查看详情-点击': {
    pagename_cn: '智优投页',
    element_tag: '智优投页#null#check_detail_button#null'
  },
  '智优投页-推广计划-曝光': {
    pagename_cn: '智优投页',
    element_tag: '智优投页#promote_plan#null#null'
  },
  '智优投页-推广计划-立即新建-点击': {
    pagename_cn: '智优投页',
    element_tag: '智优投页#promote_plan#new_create_button#null'
  },
  '智优投页-推广计划-新建推广-点击': {
    pagename_cn: '智优投页',
    element_tag: '智优投页#promote_plan#new_promote_button#null'
  },
  '智优投页-推广计划-搜索-点击': {
    pagename_cn: '智优投页',
    element_tag: '智优投页#promote_plan#select_button#null'
  },
  '智优投页-推广计划-充值-点击': {
    pagename_cn: '智优投页',
    element_tag: '智优投页#promote_plan#input_button#null'
  },
  '智优投页-推广数据-曝光': {
    pagename_cn: '智优投页',
    element_tag: '智优投页#promote_data#null#null'
  },
  '智优投页-账户管理-曝光': {
    pagename_cn: '智优投页',
    element_tag: '智优投页#account_manage#null#null'
  },
  '智优投页-操作记录-曝光': {
    pagename_cn: '智优投页',
    element_tag: '智优投页#operate_record#null#null'
  },
  '智推宝页-进入/退出': { pagename_cn: '智推宝页' },
  '智推宝页-切换投放方式-点击': {
    pagename_cn: '智推宝页',
    element_tag: '智推宝页#null#exchange_type_button#null'
  },
  '智推宝页-激活提升流量-点击': {
    pagename_cn: '智推宝页',
    element_tag: '智推宝页#null#activation_up_button#null'
  },
  '智推宝页-购买套包-点击': {
    pagename_cn: '智推宝页',
    element_tag: '智推宝页#null#buy_meal_button#null'
  },
  '智推宝页-10%额外流量-点击': {
    pagename_cn: '智推宝页',
    element_tag: '智推宝页#null#extra_flow_button#null'
  },
  '创意中心页-进入/退出': { pagename_cn: '创意中心页' },
  '创意中心页-创意列表-曝光': {
    pagename_cn: '创意中心页',
    element_tag: '创意中心页#create_list#null#null'
  },
  '创意中心页-创意列表-新建创意-点击': {
    pagename_cn: '创意中心页',
    element_tag: '创意中心页#create_list#new_create_button#null'
  },
  '创意中心页-创意列表-查看数据-点击': {
    pagename_cn: '创意中心页',
    element_tag: '创意中心页#create_list#check_data_button#null'
  },
  '创意中心页-创意列表-编辑-点击': {
    pagename_cn: '创意中心页',
    element_tag: '创意中心页#create_list#edit_button#null'
  },
  '创意中心页-创意列表-删除-点击': {
    pagename_cn: '创意中心页',
    element_tag: '创意中心页#create_list#delete_button#null'
  },
  '聚客宝页-进入/退出': { pagename_cn: '聚客宝页' },
  '聚客宝页-活动列表-曝光': {
    pagename_cn: '聚客宝页',
    element_tag: '聚客宝页#activity_list#null#null'
  }
}

export { cnNameToTrackData }
